class WebsocketClient {
  static install (Vue) {
    Object.defineProperty(Vue.prototype, '$websocket', {
      get () {
        return new WebsocketClient()
      },
    })
  }

  constructor () {
    this.instant = this
    this._webSocketEndPoint = process.env.URL_KALEIDO_CRM
    this._onOpenCallBack = null
    this._onMessageCallBack = null
    this._onCloseCallBack = null
    this._onErrorCallBack = null
  }

  set onOpenCallBack (callback) {
    this._onOpenCallBack = callback
  }
  set onMessageCallBack (callback) {
    this._onMessageCallBack = callback
  }
  set onCloseCallBack (callback) {
    this._onCloseCallBack = callback
  }
  set onErrorCallBack (callback) {
    this._onErrorCallBack = callback
  }

  connect (uri, data) {
    let url = this.createUrl(uri, data)
    let self = this
    this.webSocket = new WebSocket(url)
    this.webSocket.onopen = function (event) {
      if (typeof self._onOpenCallBack === 'function') {
        self._onOpenCallBack(event)
      }
    }
    this.webSocket.onmessage = function (event) {
      if (typeof self._onMessageCallBack === 'function') {
        self._onMessageCallBack(event)
      }
    }
    this.webSocket.onclose = function (event) {
      if (typeof self._onCloseCallBack === 'function') {
        self._onCloseCallBack(event)
      }
    }
    this.webSocket.onerror = function (event) {
      if (typeof self._onErrorCallBack === 'function') {
        self._onErrorCallBack(event)
      }
    }
  }

  createUrl (uri, data) {
    let query = ''
    Object.entries(data).forEach(([key, value]) => {
      query += key + '=' + value
      query += '&'
    })
    query = query.substr(0, query.length - 1)
    let httpProtocol = this._webSocketEndPoint.match(/(.*):\/\//g)
    let wsProtocol = ((httpProtocol === 'https://') ? 'wss://' : 'ws://')

    let url = this._webSocketEndPoint.replace(httpProtocol, wsProtocol) + uri + '?' + query
    return url
  }

  sendMessage (msg) {
    this.webSocket.send(msg)
  }

  disconnect () {
    this.webSocket.close()
  }
}

export default WebsocketClient



// WEBPACK FOOTER //
// ./src/websocket/index.js